export { SVGInject, createSVGInject } from './svg-inject';
export { SVGInject as default } from './svg-inject';
export type { SVGInjectOptions, SVGInjectFunction, FailStatus, CacheEntry } from './types';
